import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { HelpService } from '../../../services/help.service';
import { AppHelp } from '../../../models/app-help.model';
import { ShareComponent } from "../share/share.component";


@Component({
  selector: 'app-help',
  templateUrl: './help.component.html',
  styleUrls: ['./help.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatExpansionModule,
    MatIconModule,
    MatButtonModule,
    TranslateModule,
    ShareComponent,
],
  providers: [
    HelpService,
  ]
})
export default class HelpComponent {
  public items$: Observable<AppHelp[]>;
  public expandedItem: number;
  private readonly appHelpService = inject(HelpService);
  private readonly route = inject(ActivatedRoute);
  constructor() {
    this.items$ = this.appHelpService.getAll();
    this.expandedItem = parseInt(this.route.snapshot.paramMap.get('item') || '0');
  }

}
